import { HttpErrorResponse } from '@angular/common/http';
import { Application, ApplicationCounts, SuccessesAndErrors } from '@mkp/application/models';
import { createActionGroup, props } from '@ngrx/store';

export const applicationApiActions = createActionGroup({
  source: 'Application Api',
  events: {
    'Route Application Loaded Success': props<{ application: Application }>(),
    'Route Application Loaded Failure': props<{ errorResponse: HttpErrorResponse }>(),
    'Application Counts Loaded Success': props<{ applicationCounts: ApplicationCounts }>(),
    'Application Counts Loaded Failure': props<{ errorResponse: HttpErrorResponse }>(),
    'Applications Loaded Success': props<{ applications: Application[] }>(),
    'Applications Loaded Failure': props<{ errorResponse: HttpErrorResponse }>(),
    'Applications Loaded For Searched Application Success': props<{
      applications: Application[];
    }>(),
    'Applications Loaded For Searched Application Failure': props<{
      errorResponse: HttpErrorResponse;
    }>(),
    'Application Refresh Success': props<{ application: Application }>(),
    'Application Refresh Failure': props<{ errorResponse: HttpErrorResponse }>(),
    'Application Refresh Not Found': props<{ applicationId: string }>(),
    'Applications Read Refresh Success': props<{
      applications: Application[];
      missingApplicationIds: string[];
    }>(),
    // this displays the load-more separator
    'More Applications Loaded Success': props<{ applications: Application[] }>(),
    'More Applications Loaded Failure': props<{ errorResponse: HttpErrorResponse }>(),
    // "silently" means that we are not displaying the load-more separator
    'More Applications Loaded After Change Success': props<{ applications: Application[] }>(),
    'More Applications Loaded After Change Failure': props<{ errorResponse: HttpErrorResponse }>(),
    'More Applications Loaded For Searched Application Success': props<{
      applications: Application[];
    }>(),
    'More Applications Loaded For Searched Application Failure': props<{
      errorResponse: HttpErrorResponse;
    }>(),
    'Applications Update Ended': props<SuccessesAndErrors & { statusId: string }>(),
    'Applications Delete Ended': props<SuccessesAndErrors>(),
    'Applications Reload For Status Already Changed Success': props<{
      successes: Application[];
      reloadedApplications: Application[];
    }>(),
    'Application Reload For Status Already Changed Failure': props<{
      errorResponse: HttpErrorResponse;
    }>(),
  },
});

export const hasMissingApplications = ({
  missingApplicationIds,
}: ReturnType<typeof applicationApiActions.applicationsReadRefreshSuccess>): boolean =>
  missingApplicationIds.length > 0;
